import { render, staticRenderFns } from "./customer-dieboards.component.vue?vue&type=template&id=63aae9b2&scoped=true&"
import script from "./customer-dieboards.component.ts?vue&type=script&lang=ts&"
export * from "./customer-dieboards.component.ts?vue&type=script&lang=ts&"
import style0 from "./customer-dieboards.component.scss?vue&type=style&index=0&id=63aae9b2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63aae9b2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VCheckbox,VDataTable})
